/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import { ClassNames } from "@emotion/react";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import reactModalCss from "./index.css";

function onAfterOpen() {
  disableBodyScroll(document.body);
}
function onAfterClose() {
  enableBodyScroll(document.body);
}

export default function EmotionReactModal({ className, overlayClassName, ...props }) {
  return (
    <ClassNames>
      {({ css }) => (
        <ReactModal
          className={css([reactModalCss.className, className])}
          overlayClassName={css([reactModalCss.overlayClassName, overlayClassName])}
          onAfterOpen={onAfterOpen}
          onAfterClose={onAfterClose}
          {...props}
        />
      )}
    </ClassNames>
  );
}

EmotionReactModal.propTypes = {
  className: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array]),
  overlayClassName: PropTypes.shape({}),
};
